import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDate, showStatus } from "../../../../utils/commonfunction";
import * as pujaServices from "../../services/puja.services";
import { useTranslation } from "react-i18next";

const PujaView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Pujas"), url: "/admin/puja/list/1" },
        { title: t("View Puja"), url: "" },
    ];

    useEffect(() => {
        if (params.id) {
            pujaServices
                .Details(params.id)
                .then((data) => {
                    setShowDefault(data && data.data ? data.data : {});
                })
                .catch((error) => {
                    console.log("error=====>", error);
                });
        }
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">{t("View Puja")}</h6>
                            </div>
                            {showdefault && Object.keys(showdefault)?.length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>
                                                <tr>
                                                    <th>{t("Puja Image")}</th>
                                                    <td>
                                                        {showdefault?.image ? (
                                                            <img
                                                                src={showdefault.image.startsWith("http")
                                                                    ? showdefault.image
                                                                    : `${process.env.REACT_APP_API_URL || ""}/${showdefault.image}`}
                                                                alt="Puja"
                                                                style={{ maxHeight: '200px', borderRadius: '8px' }}
                                                            />
                                                        ) : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Title")} </th>
                                                    <td className="text-capitalize">
                                                        {showdefault?.title ? showdefault.title : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Price")} </th>
                                                    <td>
                                                        {showdefault?.price ? `₹ ${showdefault.price}` : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Price (USD)")} </th>
                                                    <td>
                                                        {showdefault?.price_usd ? `$ ${showdefault.price_usd}` : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Duration (Minutes)")} </th>
                                                    <td>
                                                        {showdefault?.time ? showdefault.time : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Categories")}</th>
                                                    <td>
                                                        {showdefault.PujaCategories && showdefault.PujaCategories.length > 0 ? (
                                                            showdefault.PujaCategories.map(c => c.title).join(", ")
                                                        ) : "N/A"}
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <th>{t("Puja Types")}</th>
                                                    <td>
                                                        {showdefault.PujaTypes && showdefault.PujaTypes.length > 0 ? (
                                                            showdefault.PujaTypes.map(t => t.title).join(", ")
                                                        ) : "N/A"}
                                                    </td>
                                                </tr> */}
                                                <tr>
                                                    <th>{t("Benefits")} </th>
                                                    <td className="text-capitalize">
                                                        {showdefault?.benefits ? showdefault.benefits : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Description")} </th>
                                                    <td>
                                                        {showdefault?.description ? toHtml(showdefault.description) : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Detail Description")} </th>
                                                    <td>
                                                        {showdefault?.about_description ? showdefault.about_description : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Required Materials")} </th>
                                                    <td className="text-capitalize">
                                                        {showdefault?.required_materials ? showdefault.required_materials : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Jaap Count")}</th>
                                                    <td>
                                                        {showdefault?.jaap_count ? showdefault.jaap_count : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Ahuti Count")}</th>
                                                    <td>
                                                        {showdefault?.ahuti_count ? showdefault.ahuti_count : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Mantra")}</th>
                                                    <td>
                                                        {showdefault?.manter ? showdefault.manter : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Puja Mode")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault?.puja_mode ? showdefault.puja_mode : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Status")}</th>
                                                    <td>
                                                        {toHtml(showStatus(showdefault.status ?? 0))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Created Date")}</th>
                                                    <td>
                                                        {showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Modified Date")}</th>
                                                    <td>
                                                        {showdefault.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="mt-5">
                                            <button
                                                className="btn ripple btn-dark"
                                                type="button"
                                                onClick={() => navigate(-1)}
                                            >
                                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                                {t("btn_back")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Loader />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PujaView;
